import React from 'react';
import { Link } from 'react-router-dom';
import PublicNavbar from '../../components/PublicNavbar';

const PrivacyPolicy = () => {
  return (
    <>
      <PublicNavbar />
      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 py-12 px-4">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">Política de Privacidade</h1>
          
          <div className="space-y-6 text-gray-600">
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Coleta de Dados</h2>
              <p>Coletamos os seguintes dados pessoais:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Nome completo</li>
                <li>E-mail</li>
                <li>Data de nascimento</li>
                <li>Local de nascimento</li>
                <li>Horário de nascimento</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Finalidade do Uso</h2>
              <p>Seus dados são utilizados para:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Gerar seu mapa astral personalizado</li>
                <li>Enviar atualizações sobre seu mapa</li>
                <li>Melhorar nossos serviços</li>
                <li>Comunicações relacionadas ao serviço</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Armazenamento e Segurança</h2>
              <p>Seus dados são armazenados em servidores seguros e protegidos por:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Criptografia de ponta a ponta</li>
                <li>Controle de acesso rigoroso</li>
                <li>Monitoramento constante</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Seus Direitos</h2>
              <p>Conforme a LGPD, você tem direito a:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Acessar seus dados</li>
                <li>Corrigir dados incompletos ou inexatos</li>
                <li>Solicitar a exclusão de seus dados</li>
                <li>Revogar o consentimento</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Contato</h2>
              <p>Para exercer seus direitos ou tirar dúvidas, entre em contato:</p>
              <p className="mt-2">E-mail: privacidade@mapasastrais.com</p>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link 
              to="/"
              className="text-purple-600 hover:text-purple-700 font-medium"
            >
              ← Voltar para a página inicial
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
